export const CREATE_MENU_LINK_SUCCESS = 'MENU/CREATE_MENU_LINK_SUCCESS';
export const CREATE_MENU_LINK_ERROR = 'MENU/CREATE_MENU_LINK_ERROR';
export const FETCH_MENU_LINKS_LIST = 'MENU/FETCH_MENU_LINKS_LIST';
export const FETCH_MENU_LINKS_LIST_ERROR = 'MENU/FETCH_MENU_LINKS_LIST_ERROR';
export const CLEAR_FETCH_MENU_LINKS_LIST = 'MENU/CLEAR_FETCH_MENU_LINKS_LIST';
export const CLEAR_CREATE_MENU_LINK = 'MENU/CLEAR_CREATE_MENU_LINK';
export const DELETE_MENU_LINK_SUCCESS = 'MENU/DELETE_MENU_LINK_SUCCESS';
export const DELETE_MENU_LINK_ERROR = 'MENU/DELETE_MENU_LINK_ERROR';
export const PATCH_MENU_LINK_SUCCESS = 'MENU/PATCH_MENU_LINK_SUCCESS';
export const PATCH_MENU_LINK_ERROR = 'MENU/PATCH_MENU_LINK_ERROR';
export const CLEAR_DELETE_MENU_LINK = 'MENU/CLEAR_DELETE_MENU_LINK';

export const PATCH_MENUS_ITEM_SUCCESS = 'MENU/PATCH_MENUS_ITEM_SUCCES';
export const PATCH_MENUS_ITEM_ERROR = 'MENU/PATCH_MENUS_ITEM_ERROR';
export const CLEAR_PATCH_MENUS_ITEM = 'MENU/CLEAR_PATCH_MENUS_ITEM';

export const CREATE_MENUS_ITEM_SUCCESS = 'MENU/CREATE_MENUS_ITEM'; 
export const CREATE_MENUS_ITEM_ERROR = 'MENU/CREATE_MENUS_ITEM_ERROR';
export const CLEAR_CREATE_MENUS_ITEM = 'MENU/CLEAR_CREATE_MENUS_ITEM';

export const DELETE_MENUS_ITEM_SUCCESS = 'MENU/DELETE_MENUS_ITEM_SUCCESS';
export const DELETE_MENUS_iTEM_ERROR = 'MENU/DELETE_MENUS_iTEM_ERROR';
export const CLEAR_DELETE_MENUS_ITEM = 'MENU/CLEAR_DELETE_MENUS_ITEM';

export const APPLY_MENU_LINK_DRAG = 'MENU/APPLY_MENU_LINK_DRAG';
export const APPLY_MENU_LINK_DRAG_ERROR = 'MENU/APPLY_MENU_LINK_DRAG_ERROR';
export const CLEAR_MENU_LINK_DRAG = 'MENU/CLEAR_MENU_LINK_DRAG';

export const ADD_MENUS_IMAGES_SUCCESS = 'MENU/ADD_MENUS_IMAGES_SUCCESS';
export const ADD_MENUS_IMAGES_ERROR = 'MENU/ADD_MENUS_IMAGES_ERROR';
export const CLEAR_ADD_MENUS_IMAGES = 'MENU/CLEAR_ADD_MENUS_IMAGES';

export const DELETE_IMAGES_SUCCESS = 'MENUS/DELETE_IMAGES_SUCCESS';
export const DELETE_IMAGES_ERROR = 'MENUS/DELETE_IMAGES_ERROR';
export const CLEAR_DELETE_IMAGES = 'MENUS/CLEAR_DELETE_IMAGES';